import { composeIO } from 'react-compose-io'
import { erroProcessamentoIO } from './ErroProcessamento.IO'
import { ErroProcessamentoView } from './ErroProcessamento.View'

export const ErroProcessamento = composeIO(ErroProcessamentoView, erroProcessamentoIO)
